import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { atomWithStorage, useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { queryMe } from '../me/api';
import type { ImageGenerationPageData } from './model';

const imageGenerationPageDataFamilyAtom = atomFamily((accountId: string) =>
  atomWithStorage<ImageGenerationPageData>(
    `${accountId}_v2_image_generation_page_data`,
    {},
    undefined,
    { getOnInit: true },
  ),
);

export function useReadImageGenerationPageData() {
  const { data } = useQuery(queryMe);
  return useAtomCallback(
    useCallback(
      (get) => get(imageGenerationPageDataFamilyAtom(data.name)),
      [data.name],
    ),
  );
}

export function useSetImageGenerationPageData() {
  const { data } = useQuery(queryMe);
  return useSetAtom(imageGenerationPageDataFamilyAtom(data.name));
}
